import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import EntertainerResult from '../components/EntertainerResult';

class SearchResultPage extends Component {
  static propTypes = {
    userfavourite: PropTypes.array.isRequired,
    inputs: PropTypes.array.isRequired
  }

  static defaultProps = {
    userfavourite: [],
    inputs: []
  }

  render() {

    var results = this.props.results.userfavourite;
    return (
      <EntertainerResult entities={ results } />
      );
  }
}

SearchResultPage = connectToStores(SearchResultPage, ['EntertainerResultStore'], (stores, props) => {
  return {
    results: stores.EntertainerResultStore.get()
  };
});

export default SearchResultPage;



// WEBPACK FOOTER //
// ./src/pages/SearchResultPage.js